module.exports = __webpack_public_path__ + "img/Paypal wallet-screenshot.2eba9f61.png";